import PropTypes from 'prop-types';
// @mui
import { Box, Link, Stack, Typography, Breadcrumbs, IconButton } from '@mui/material';
//
import LinkItem from './LinkItem';
import Iconify from '../iconify';
import { useNavigate } from 'react-router';

// ----------------------------------------------------------------------

CustomBreadcrumbs.propTypes = {
  sx: PropTypes.object,
  action: PropTypes.node,
  links: PropTypes.array,
  heading: PropTypes.string,
  moreLink: PropTypes.array,
  activeLast: PropTypes.bool,
};

export default function CustomBreadcrumbs({ enable_return, links, action, heading, moreLink, activeLast, sx, ...other }) {
  const lastLink = links[links.length - 1]?.name;
  const navigate = useNavigate()

  return (
    <Box sx={{ mb: 5, ...sx }}>
      <Stack direction="row" alignItems="center">
      
        <Box sx={{ flexGrow: 1 }}>
          {/* HEADING */}
          
          {heading && (
            <Stack direction='row' alignItems='center'>
              {enable_return && (
                <IconButton sx={{padding:1, mt:-1}} onClick={() => navigate(-1)}>
                  <Iconify icon='material-symbols:arrow-back-ios-new-rounded'/>
                </IconButton>
              )}
              <Typography variant="h4" gutterBottom>
                {heading}
              </Typography>
            </Stack>
            
          )}

          {/* BREADCRUMBS */}
          {links && !!links.length && (
            <Breadcrumbs separator={<Separator />} {...other}>
              {links.map((link) => (
                <LinkItem key={link?.name || ''} link={link} activeLast={activeLast} disabled={link?.name === lastLink} />
              ))}
            </Breadcrumbs>
          )}
        </Box>

        {action && <Box sx={{ flexShrink: 0 }}> {action} </Box>}
      </Stack>

      {/* MORE LINK */}
      {!!moreLink && (
        <Box sx={{ mt: 2 }}>
          {moreLink.map((href) => (
            <Link
              noWrap
              key={href}
              href={href}
              variant="body2"
              target="_blank"
              rel="noopener"
              sx={{ display: 'table' }}
            >
              {href}
            </Link>
          ))}
        </Box>
      )}
    </Box>
  );
}

// ----------------------------------------------------------------------

function Separator() {
  return <Box component="span" sx={{ width: 4, height: 4, borderRadius: '50%', bgcolor: 'text.disabled' }} />;
}
